/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoConnectedMemberDto
 */
export interface WebApiCustomListsDtoConnectedMemberDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoConnectedMemberDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoConnectedMemberDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoConnectedMemberDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoConnectedMemberDto
     */
    memberFieldId?: number;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoConnectedMemberDto interface.
 */
export function instanceOfWebApiCustomListsDtoConnectedMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoConnectedMemberDtoFromJSON(json: any): WebApiCustomListsDtoConnectedMemberDto {
    return WebApiCustomListsDtoConnectedMemberDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoConnectedMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoConnectedMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'memberFieldId': !exists(json, 'memberFieldId') ? undefined : json['memberFieldId'],
    };
}

export function WebApiCustomListsDtoConnectedMemberDtoToJSON(value?: WebApiCustomListsDtoConnectedMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'memberFieldId': value.memberFieldId,
    };
}

